<template>
  <div class="legal-page">
    <a href="#" @click.prevent="back()" class="nav-back">
      <svg-icon icon="back"/> <span class="text-capitalize-first">{{$t('back')}}</span>
    </a>
    <h1>{{title}}</h1>
    <div class="legal-content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.nav-back {
  display: flex;
  gap: var(--margin-xs);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5%;
  align-items: center;
  color: #FFFFFFA3;
  text-decoration: none;
  padding-bottom: var(--margin-sm);
}

.legal-page {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
}

.legal-content {
  display: flex;
  flex-direction: column;
  gap: var(--margin-sm);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #FFFFFFA3;
  padding-bottom: var(--margin-xl);

  :deep(h2) {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    margin-top: var(--margin-sm);
  }

  :deep(p) {
    margin: 0;
  }

  :deep(ul) {
    margin: 0;
    padding-left: var(--margin-normal);
  }

  :deep(a) {
    color: var(--primary-color);
  }
}
</style>

<script setup lang="ts">
import {useRouter} from "vue-router";
import SvgIcon from "@/components/SvgIcon.vue";
import {$t} from "@/i18n";

defineProps<{
  title: string
}>()

const router = useRouter();

const back = () => {
  if (window.history.state?.back) {
    router.back()
  } else {
    router.push('/')
  }
}
</script>
